import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";
import FaceGenerator from "../views/FaceGenerator.vue";
import Gallery from "../views/Gallery.vue";
import NotFound from "../views/NotFound.vue";
import { getSeoMetadata, updatePageMetadata } from "../utils/seo.js";
import i18n from "../i18n";

// 支持的语言列表
const supportedLocales = ["zh", "de", "vi", "th", "id", "ms"];

// 基础路由
const baseRoutes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      pageName: "home",
    },
  },
  {
    path: "/generator",
    name: "FaceGenerator",
    component: FaceGenerator,
    meta: {
      pageName: "generator",
    },
  },
  {
    path: "/gallery",
    name: "Gallery",
    component: Gallery,
    meta: {
      pageName: "gallery",
    },
  },
];

// 为每种语言生成对应路由
const routes = [
  ...baseRoutes,
  // 添加语言前缀路由
  ...supportedLocales.flatMap((locale) =>
    baseRoutes.map((route) => ({
      path: `/${locale}${route.path === "/" ? "" : route.path}`,
      component: route.component,
      meta: {
        ...route.meta,
        locale: locale,
      },
    }))
  ),
  // 404路由
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: {
      pageName: "notFound",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 更新当前路由的SEO元数据
const updateRouteSeoMetadata = (to) => {
  // 从路由中获取语言设置，如果没有则使用当前全局设置
  const routeLocale = to.meta.locale;

  if (routeLocale && routeLocale !== i18n.global.locale.value) {
    // 如果路由中指定了语言，则更新全局语言设置
    i18n.global.locale.value = routeLocale;
    localStorage.setItem("locale", routeLocale);
  }

  const currentLocale = i18n.global.locale.value;
  const pageName = to.meta.pageName || "home";
  const seoMetadata = getSeoMetadata(currentLocale, pageName);
  updatePageMetadata(seoMetadata);
};

// 路由前置钩子，检测URL中的语言参数
router.beforeEach((to, from, next) => {
  // 如果URL路径以语言代码开头
  const pathSegments = to.path.split("/").filter(Boolean);
  const firstSegment = pathSegments[0];

  if (supportedLocales.includes(firstSegment)) {
    // 已经是语言路径，无需处理
    next();
  } else {
    // 检查localStorage中的语言设置
    const savedLocale = localStorage.getItem("locale");

    // 如果用户有语言偏好且不是英语，则重定向到对应语言路径
    if (
      savedLocale &&
      savedLocale !== "en" &&
      supportedLocales.includes(savedLocale)
    ) {
      // 构建带语言前缀的新路径
      const redirectPath = `/${savedLocale}${to.path}`;
      next({ path: redirectPath, replace: true });
    } else {
      // 使用默认语言（英语）
      next();
    }
  }
});

// 路由后置钩子，更新SEO元数据
router.afterEach((to) => {
  updateRouteSeoMetadata(to);
});

export default router;
